import { NgModule } from '@angular/core';
import { YangFuriganaDirective } from './yang-furigana.directive';

@NgModule({
  declarations: [YangFuriganaDirective],
  imports: [],
  exports: [YangFuriganaDirective]
})
export class YangFuriganaModule {}
